import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  input,
  ViewChild,
  AfterViewInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatChipOption, MatChipsModule } from '@angular/material/chips';
import { VisorgisService } from '../../services/visorgis.service';
import { NoTranslateMaterialSymbolsDirective } from '../../../../shared/directives/noTranslateMaterialSymbols.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ChipsContainerComponent } from '../../../../shared/components/mapa/components/chips-container/chips-container.component';
import { ChipsMapButtonsComponent } from '../../../../shared/components/mapa/components/chips-map-buttons/chips-map-buttons.component';

@Component({
  selector: 'app-filtros-rapidos',
  imports: [
    MatChipsModule,
    NoTranslateMaterialSymbolsDirective,
    MatButtonModule,
    MatIconModule,
    ChipsContainerComponent,
    ChipsMapButtonsComponent,
  ],
  templateUrl: './filtrosRapidos.component.html',
  styleUrl: './filtrosRapidos.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FiltrosRapidosComponent implements AfterViewInit {
  @ViewChild('filtroHidrantes') filtroHidrantes: ChipsMapButtonsComponent;
  @ViewChild('filtroEstaciones') filtroEstaciones: MatChipOption;
  @ViewChild('filtroTomas') filtroTomas: MatChipOption;
  @ViewChild('leftButton') leftButton: ElementRef<HTMLButtonElement>;
  @ViewChild('rightButton') rightButton: ElementRef<HTMLButtonElement>;
  @ViewChild('container') container: ElementRef<HTMLDivElement>;

  width = input<number>(0);

  constructor(private readonly service: VisorgisService) {}

  ngAfterViewInit() {
    // Forzar una verificación de scroll después de que la vista se haya inicializado
    // Esto asegura que los botones aparezcan si el contenido desborda inicialmente
    setTimeout(() => {
      // Disparar un evento de resize para que el componente hijo (chips-container) recalcule
      window.dispatchEvent(new Event('resize'));
    }, 500);
  }

  showAllFilters() {
    this.service.toggleMenu();
  }

  showOnlyHidrantes() {
    if (this.filtroHidrantes.selected) {
      return this.service.showOnlyHidrantes();
    }
    this.service.showAllFilters();
  }

  showOnlyEstaciones() {
    if (this.filtroEstaciones.selected) {
      return this.service.showOnlyEstaciones();
    }
    this.service.showAllFilters();
  }

  showOnlyTomas() {
    if (this.filtroTomas.selected) {
      return this.service.showOnlyTomas();
    }
    this.service.showAllFilters();
  }
}
